import makeApi from "../../libs/axios/api";

interface ShipmentTrackingResponse {
  data: {
    erpTrackingNumber?: string;
    [key: string]: any;
  } | null;
  message?: string;
}

const apiPromise = makeApi();

const getShipmentTracking = async (
  orderId: string
): Promise<ShipmentTrackingResponse> => {
  const api = await apiPromise;
  try {
    const response = await api.get(`/order/${orderId}/shipmenttracking`);

    return response;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.message || error.message || "Something went wrong";
    throw new Error(errorMsg);
  }
};

export default getShipmentTracking;
